import React, { Component, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import '../../../Assets/css/index.scss'
import Loading from '../../../Libs/Helper/Loading'
import { getApps, setCaptcha } from '../Reducer/AppReducer';
import ReCAPTCHA from "react-google-recaptcha";

import NetworkInformation from "../../../Libs/Devices/NetworkInformation"

import { I18nProvider } from '../../../Libs/i18n/I18nContext';
import PrivateRoute from '../../../Libs/Security/PrivateRoutes';
import Layouts from '../../Layouts/Component/Layouts';

import Logout from '../../LoginForm/Component/Logout';
import NotFound from '../../../Libs/Helper/NotFound'
import Errors from '../../../Libs/Helper/Errors'
import { Skeleton } from 'antd'
import { LoadScript } from '../../../Libs/Services/GoogleLoader'

const Login = React.lazy(() => import('../../../Pages/Login'));

const Dashboard = React.lazy(() => import('../../../Pages/Dashboard'));
const Members = React.lazy(() => import('../../../Pages/Settings/Members'));

const Company = React.lazy(() => import('../../../Pages/Settings/Company'));
const Definitions = React.lazy(() => import('../../../Pages/Settings/Definitions'));
const PointRules = React.lazy(() => import('../../../Pages/PointRules'));
const PointTerms = React.lazy(() => import('../../../Pages/PointTerms'));
const Tickets = React.lazy(() => import('../../../Pages/Tickets'));
const Reservations = React.lazy(() => import('../../../Pages/Reservations'));
const Rules = React.lazy(() => import('../../../Pages/Rules'));
const PointStrategies = React.lazy(() => import('../../../Pages/PointStrategies'));

// Admin
const AdminLogin = React.lazy(() => import('../../AdminAuth/Component/AdminLogin'));
const AdminDashboard = React.lazy(() => import('../../../Pages/Admin/AdminDashboard'));
const AdminReservations = React.lazy(() => import('../../../Pages/Admin/AdminReservations'));
const AdminUsers = React.lazy(() => import('../../../Pages/Admin/AdminUsers'));
const AdminCompanies = React.lazy(() => import('../../../Pages/Admin/AdminCompanies'));
const AdminLoyaltyTiers = React.lazy(() => import('../../../Pages/Admin/AdminLoyaltyTiers'));
const AdminTickets = React.lazy(() => import('../../../Pages/Admin/AdminTickets'));
const AdminReports = React.lazy(() => import('../../../Pages/Admin/AdminReports'));
const AdminNotifications = React.lazy(() => import('../../../Pages/Admin/AdminNotifications'));
const AdminLayouts = React.lazy(() => import('../../AdminAuth/Component/AdminLayouts'));
const AdminPrivateRoute = React.lazy(() => import('../../AdminAuth/Component/AdminPrivateRoute'));




export class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            recaptchaLoading: true
        }
        this.recaptchaRef = React.createRef();
        this.isComponentMounted = true;
    }
    componentDidMount() {
        this.init()
    }

    init = async () => {
        try {
            LoadScript();
            this.props.getApps();
        } catch (error) {

        }

    }


    asyncScriptOnLoad = () => {
        this.setState({
            recaptchaLoading: false
        })
    }

    render() {

        const { loading, error, errorData } = this.props.Apps;

        return (
            <>
                {(loading && this.state.recaptchaLoading) ?
                    <Loading />
                    :

                    <I18nProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route path='/' element={

                                    <Suspense fallback={<Loading />}>
                                        <Login recaptchaRef={this.recaptchaRef} />
                                    </Suspense>
                                } />

                              

                                <Route path='/Logout' element={

                                    <Suspense fallback={<Loading />}>
                                        <Logout />
                                    </Suspense>
                                } />
                                <Route path='/Login' element={
                                    <Suspense fallback={<Loading />}>
                                        <Login recaptchaRef={this.recaptchaRef} />
                                    </Suspense>} />


                                <Route exact element={<PrivateRoute />}>
                                    <Route exact path="/Dashboard" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <Dashboard />
                                            </Suspense>
                                        </Layouts>
                                    } />


                                    <Route exact path="/Members" element={
                                        <Layouts>

                                            <Suspense fallback={<Skeleton />}>
                                                <Members />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route exact path="/Company" element={
                                        <Layouts>

                                            <Suspense fallback={<Skeleton />}>
                                                <Company />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route exact path="/Definitions" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <Definitions />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route exact path="/PointRules" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <PointRules />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route exact path="/PointTerms" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <PointTerms />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route exact path="/Tickets" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <Tickets />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route exact path="/Reservations" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <Reservations />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    {/* Rules ve PointStrategies admin-only — user-side route'u yok.
                                       Sadece /Admin/Rules, /Admin/PointStrategies erişilebilir. */}

                                </Route>

                                {/* Admin: ayrı login ekranı + ayrı route guard + ayrı layout */}
                                <Route path='/AdminLogin' element={
                                    <Suspense fallback={<Loading />}>
                                        <AdminLogin />
                                    </Suspense>
                                } />
                                <Route element={
                                    <Suspense fallback={<Skeleton />}>
                                        <AdminPrivateRoute />
                                    </Suspense>
                                }>
                                    <Route path='/Admin/Dashboard' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminDashboard />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Definitions' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <Definitions />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Members' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <Members />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Company' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <Company />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Rules' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <Rules />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/PointStrategies' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <PointStrategies />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Reservations' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminReservations />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Users' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminUsers />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Companies' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminCompanies />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/LoyaltyTiers' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminLoyaltyTiers />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Tickets' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminTickets />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Reports' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminReports />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                    <Route path='/Admin/Notifications' element={
                                        <Suspense fallback={<Skeleton />}>
                                            <AdminLayouts>
                                                <AdminNotifications />
                                            </AdminLayouts>
                                        </Suspense>
                                    } />
                                </Route>

                                <Route path="*" element={<NotFound />} />

                            </Routes>
                        </BrowserRouter>
                        <NetworkInformation />

                        <ReCAPTCHA
                            ref={this.recaptchaRef}
                            onChange={this.onChange}
                            badge={'bottomright'}
                            size="invisible"
                            onExpired={this.onExpired}
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
                            asyncScriptOnLoad={this.asyncScriptOnLoad}
                        />
                    </I18nProvider>
                }

                {error &&
                    <Errors errorData={errorData} />
                }

            </>
        )
    }
}

const mapStateToProps = (state) => ({
    Apps: state.Apps
})

const mapDispatchToProps = {
    getApps,
    setCaptcha
}

export default connect(mapStateToProps, mapDispatchToProps)(App)